<td colspan="{{columnCount}}">
    {{#if hasRowSelector}}
        <div class="checkbox">
            <input type="checkbox" id="row-selector-{{ groupId }}" class="group-row-selector column-row-group-selector-{{ groupId }}" value="{{ value }}" data-model-cid="{{ groupId }}"/>
            <label for="row-selector-{{ groupId }}">{{groupTitle}}</label>
        </div>
    {{else}}
        <span>{{groupTitle}}</span>
    {{/if}}
</td>
